import { render, staticRenderFns } from "./DistanceSpeedStatsTable.vue?vue&type=template&id=c1fbbb8c&scoped=true&"
import script from "./DistanceSpeedStatsTable.vue?vue&type=script&lang=js&"
export * from "./DistanceSpeedStatsTable.vue?vue&type=script&lang=js&"
import style0 from "./DistanceSpeedStatsTable.vue?vue&type=style&index=0&id=c1fbbb8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fbbb8c",
  null
  
)

export default component.exports